<div>
    <div>
        <div>
            <form>
                <div class="input-group">
                    <div class="input-group-text">
                        <i class="bi bi-people"></i>
                    </div>
                    <input
                        [(ngModel)]="searchValue"
                        type="text"
                        class="form-control"
                        placeholder="Search Users"
                        name="searchValue"
                        (ngModelChange)="searchValueUpdate.next($event)"
                    />
                </div>
            </form>
        </div>

        <app-view-users-import
            [keycloakUsers]="notCachedModels"
        ></app-view-users-import>

        <table mat-table [dataSource]="userModelsSource" class="table-list">
            <ng-container matColumnDef="control">
                <th mat-header-cell *matHeaderCellDef>Control</th>
                <td mat-cell *matCellDef="let userModel">
                    <button
                        *ngIf="userModel.username != openIdProfile!.id"
                        class="btn btn-sm btn-danger"
                        title="Deposit"
                    >
                        <i
                            (click)="deposit(userModel)"
                            class="bi bi-arrow-up"
                        ></i>
                    </button>
                    &nbsp;
                    <button
                        *ngIf="userModel.username != openIdProfile!.id"
                        class="btn btn-sm btn-success"
                        title="Withdraw"
                    >
                        <i
                            (click)="withdrawal(userModel)"
                            class="bi bi-arrow-down"
                        ></i>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>Open ID</th>
                <td mat-cell *matCellDef="let userModel">
                    {{ userModel.username }}
                </td>
            </ng-container>

            <ng-container matColumnDef="balance">
                <th mat-header-cell *matHeaderCellDef>Balance</th>
                <td mat-cell *matCellDef="let userModel">
                    {{ userModel.balance | currency }}
                </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email</th>
                <td mat-cell *matCellDef="let userModel">
                    {{ userModel.email }}
                </td>
            </ng-container>

            <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef>First Name</th>
                <td mat-cell *matCellDef="let userModel">
                    {{ userModel.first_name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef>Last Name</th>
                <td mat-cell *matCellDef="let userModel">
                    {{ userModel.last_name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="member">
                <th mat-header-cell *matHeaderCellDef>Member</th>
                <td mat-cell *matCellDef="let userModel">
                    <span *ngIf="userModel.isMember">Yes</span>
                    <span *ngIf="!userModel.isMember">No</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="operator">
                <th mat-header-cell *matHeaderCellDef>Operator</th>
                <td mat-cell *matCellDef="let userModel">
                    <span *ngIf="userModel.isOperator">Yes</span>
                    <span *ngIf="!userModel.isOperator">No</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="username">
                <th mat-header-cell *matHeaderCellDef>OpenId</th>
                <td mat-cell *matCellDef="let userModel">
                    {{ userModel.username }}
                </td>
            </ng-container>

            <ng-container matColumnDef="date_joined">
                <th mat-header-cell *matHeaderCellDef>Date Joined</th>
                <td mat-cell *matCellDef="let userModel">
                    {{ userModel.date_joined | date : "longDate" }}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnHeadings"></tr>
            <tr mat-row *matRowDef="let row; columns: columnHeadings"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
        </mat-paginator>
    </div>
</div>
